import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import './style.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import goImg from '@/components/go-img.vue'

Vue.config.productionTip = false

Vue.component('go-img', goImg)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
